import React from "react";
import { Grid, Responsive, Embed } from "semantic-ui-react";
import "./App.css";
import { connect } from "react-redux";

import ColorPanel from "./ColorPanel/ColorPanel";
import SidePanel from "./SidePanel/SidePanel";
import Messages from "./Messages/Messages";
import MetaPanel from "./MetaPanel/MetaPanel";
import HelloRenoHeader from "./layout/Header";
import HelloRenoFooter from "./layout/Footer";

const App = ({
  currentUser,
  currentChannel,
  isPrivateChannel,
  userPosts,
  userLikes
}) => (
  <React.Fragment>
    {localStorage.getItem("myData") && <HelloRenoHeader />}
    <Grid columns="equal" className="app" style={{ background: "#eee" }}>
      {/* カラーパネル */}
      {/* <ColorPanel /> */}
      {/* <div class="sidebar"> */}

      {!localStorage.getItem("myData") && (
        <SidePanel
          key={currentUser && currentUser.uid}
          currentUser={currentUser}
          currentChannel={currentChannel}
        />
      )}

      {/* </div> */}
      <Grid.Column
        style={
          localStorage.getItem("myData")
            ? { marginLeft: 0 }
            : { marginLeft: 230 }
        }
      >
        {/* <Grid.Column style={{ marginLeft: 0 }}> */}
        <Messages
          key={currentChannel && currentChannel.id}
          currentChannel={currentChannel}
          currentUser={currentUser}
          isPrivateChannel={isPrivateChannel}
        />
      </Grid.Column>

      <Responsive as={Grid.Column} minWidth={980} width={6}>
        <Grid.Column>
          <MetaPanel
            key={currentChannel && currentChannel.id}
            userPosts={userPosts}
            currentChannel={currentChannel}
            isPrivateChannel={isPrivateChannel}
            currentUser={currentUser}
            userLikes={userLikes}
          />
        </Grid.Column>
      </Responsive>
    </Grid>
    {localStorage.getItem("myData") && <HelloRenoFooter />}
  </React.Fragment>
);

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
  currentChannel: state.channel.currentChannel,
  isPrivateChannel: state.channel.isPrivateChannel,
  userPosts: state.channel.userPosts,
  userLikes: state.channel.userLikes
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js